module.exports = do ->
   _ = require("underscore").default
   EverTrue = require("app")
   AuthApi = require("entities/auth/auth-api")


   class LidsServices extends AuthApi.Model
      urlRoot: -> "lids/services/#{@get("service")}"
